// @ts-nocheck
import React, { useRef, useState, useEffect } from 'react';

export interface BadgeScrollTextProps {
    text: string;
    className?: string;
    style?: React.CSSProperties;
    maxWidthClass?: string;
}

export const BadgeScrollText: React.FC<BadgeScrollTextProps> = ({
    text,
    className = '',
    style,
    maxWidthClass = 'max-w-[85px] sm:max-w-[125px]'
}) => {
    const containerRef = useRef<HTMLDivElement>(null);
    const measureRef = useRef<HTMLSpanElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (containerRef.current && measureRef.current) {
                const availableWidth = containerRef.current.clientWidth - 2;
                const textWidth = measureRef.current.scrollWidth;
                setIsOverflowing(textWidth > availableWidth + 2);
            }
        };

        checkOverflow();

        let observer: ResizeObserver | null = null;
        if (containerRef.current) {
            observer = new ResizeObserver(checkOverflow);
            observer.observe(containerRef.current);
        }

        window.addEventListener('resize', checkOverflow);
        return () => {
            if (observer) observer.disconnect();
            window.removeEventListener('resize', checkOverflow);
        };
    }, [text]);

    return (
        <div ref={containerRef} className={`overflow-hidden relative min-w-0 ${maxWidthClass} flex items-center select-none`}>
            {/* Invisible measurement element */}
            <span
                ref={measureRef}
                className={`whitespace-nowrap invisible absolute -top-[9999px] left-0 pointer-events-none ${className}`}
                style={style}
                aria-hidden="true"
            >
                {text}
            </span>

            {isOverflowing ? (
                <div
                    className="w-full overflow-hidden relative flex items-center"
                    style={{
                        maskImage: 'linear-gradient(to right, transparent, black 4px, black calc(100% - 4px), transparent)',
                        WebkitMaskImage: 'linear-gradient(to right, transparent, black 4px, black calc(100% - 4px), transparent)'
                    }}
                >
                    <div
                        className="whitespace-nowrap flex gap-6"
                        style={{
                            animation: `marquee ${Math.max(5, text.length * 0.35)}s linear infinite`
                        }}
                    >
                        <span className={className} style={style}>{text}</span>
                        <span className={className} style={style}>{text}</span>
                    </div>
                </div>
            ) : (
                <span className={`whitespace-nowrap block w-full ${className}`} style={style}>
                    {text}
                </span>
            )}
        </div>
    );
};

export default BadgeScrollText;
